import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://linkedin.com/in/sterlyderacy'
      className='link footer_link'
    >
      Sterly Deracy © 2023
    </a>
  </footer>
)

export default Footer
